import React from "react";

const Section2 = ({ state, onChange, onAddRow, onRemoveRow }) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12 ">
          <div className="appraisal-report-table-responsive">
            <table className="assessment-table" cellSpacing={0}>
              <tbody>
                {/* Title */}
                <tr>
                  <td className="hd-s2 pd10" colSpan={4}>
                    <p>2. Major inspections and schedule of the following month</p>
                  </td>
                </tr>

                {/* Header Row */}
                <tr>
                  <td className="td-s1">
                    <p className="s1">#</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Inspection</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Schedule</p>
                  </td>
                  <td className="td-s1">
                    <p className="s1">Action</p>
                  </td>
                </tr>

                {/* Dynamic Rows */}
                {state.map((row, index) => (
                  <tr key={index}>
                    <td className="td-s1 text-center">{index + 1}</td>

                    {/* Inspection */}
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Inspection"
                        name="inspection"
                        value={row.inspection.value}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td>

                    {/* Schedule */}
                    <td className="tb-input-value">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Schedule"
                        name="schedule"
                        value={row.schedule.value}
                        onChange={(e) => onChange(e, index)}
                      />
                    </td>

                    {/* Remove Row */}
                    <td className="tb-input-value text-center">
                      <button
                        style={{
                          backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                          borderColor: "#2b5a7e"
                        }}
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => onRemoveRow(index)}
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}

                {/* Add Row */}
                <tr>
                  <td colSpan={4}>
                    <button
                      style={{
                        backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                        borderColor: "#2b5a7e"
                      }}
                      type="button"
                      className="btn btn-primary btn-sm ms-2"
                      onClick={onAddRow}
                    >
                      + Add Row
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Section2;
